import React from 'react';
import Views from '.';
import Content from './content';

const BodyContentView = ({title, left, right, caption}) => {
  return (
    <Views title={title} left={left} right={right}>
      <Content caption={caption} />
    </Views>
  );
};

export default BodyContentView;
